<template>
    <div class="about-dizhi center-wrapper">
      <div class="about-dizhi-left">
        <div class="about-dizhi-left-top">
          <h1 class="about-dizhi-title">咨询业务</h1>
          <ul class="about-dizhi-left-top-content" style="margin-top: 5px;">
            <li v-for="item of zxywList1" :key="item">
              {{item}}
            </li>
          </ul>
          <ul class="about-dizhi-left-top-content">
            <li v-for="item of zxywList2" :key="item">
              {{item}}
            </li>
          </ul>
        </div>
        <div class="about-dizhi-left-bottom">
          <h1 class="about-dizhi-title">联系我们</h1>
          <div class="about-dizhi-right-top-content" style="margin-top: 5px;">
            <p>联系地址：广州市天河区大观中路492号慧创百思产业园A140</p>
            <p>联系电话：400-900-5991</p>
          </div>
        </div>
      </div>
      <div class="about-dizhi-right">
<!--        <img src="@/assets/img/aboutUsDizhi.svg" alt="" width="100%">-->
        <baidu-map :scroll-wheel-zoom="true" class="bm-view" :center="map.center" :zoom="map.zoom">
          <bm-marker :position="map.center" :dragging="true" @click="infoWindowOpen">
            <bm-info-window :show="map.show" @close="infoWindowClose" @open="infoWindowOpen">
              <p class="map-title">甄宝阁</p>
              <p class="detail">广州市天河区大观中路492号<br>慧创百思产业园A140</p>
            </bm-info-window>
          </bm-marker>
        </baidu-map>
      </div>
    </div>
</template>

<script>
export default {
  data () {
    return {
      zxywList1: ['珠宝检测站入驻','珠宝检测业务系统','珠宝快速质检系统','智能拍照系统'],
      zxywList2: ['检测证书覆膜机','软件网站小程序定制','Al 非标机械设计研发',],
      map: {
        center: {lng: 113.42914, lat: 23.175511},
        zoom: 15,
        show: true
      }
    }
  },
  methods: {
    infoWindowClose () {
      this.map.show = false
    },
    infoWindowOpen () {
      this.map.show = true
    }
  }
}
</script>

<style lang='scss'>

  .about-dizhi {
    display: flex;
    justify-content: space-between;
    align-items: center;
    >div {
      width: 48%;
    }
    .about-dizhi-title {
      font-weight: 600;
      font-size: 18px;
    }
    .bm-view {
      width: 100%;
      height: 330px;
      border: solid 6px #fff;
      .map-title {
        color: rgb(32, 147, 202);
        font-size: 1.1rem;
        margin: 5px;
        font-weight: bold;
      }
      .detail{
        margin: 5px;
        font-size: 0.9rem;
        color: rgb(114, 113, 113);
      }
    }
    .about-dizhi-left {
      display: flex;
      flex-direction: column;
      .about-dizhi-left-top-content {
        display: flex;
        color: rgb(114,113,113);
        flex-wrap: wrap;
        li {
          padding: 0 10px;
          margin-top: 15px;
          border-right: 1px solid rgb(114,113,113);
        }
        li:first-child{
          padding-left: 0;
        }
        li:last-child{
          border-right: none;
        }
      }
      .about-dizhi-left-bottom {
        margin-top: 50px
      }
      .about-dizhi-right-top-content {
        color: rgb(114,113,113);
        p {
          margin-top: 15px;
        }
      }
    }
    padding: 40px 0 60px 0;
  }
</style>